import { DealType, DealRating, Currency, SortOrder } from 'types';
import { CommonFilterValues } from '../types';

export interface CommonSecondaryDealFilterValues extends CommonFilterValues {
  minDuration?: number;
  maxDuration?: number;
  minPrincipal?: number;
  maxPrincipal?: number;
  minNominalInterestRate?: number;
  maxNominalInterestRate?: number;
  minDefaultRate?: number;
  maxDefaultRate?: number;
  minDiscount?: number;
  maxDiscount?: number;
}

export interface SecondaryDealFilterValues extends CommonSecondaryDealFilterValues {}

export type SecondaryDealFilterPayload = {
  productType?: DealType[];
  rating?: DealRating[];
  currency?: Currency[];
  minDuration?: number;
  maxDuration?: number;
  minPrincipal?: number;
  maxPrincipal?: number;
  minNominalInterestRate?: number;
  maxNominalInterestRate?: number;
  minDefaultRate?: number;
  maxDefaultRate?: number;
  minDiscount?: number;
  maxDiscount?: number;
  sortBy?: string;
  sortOrder?: SortOrder;
};

export enum ESecondaryDealSortOption {
  PublicationDate = 'PublicationDate',
  Currency = 'Currency',
  Price = 'Price',
  PriceDiscount = 'PriceDiscount',
  NominalValue = 'NominalValue',
  IRR = 'IRR',
  Duration = 'Duration',
  DefaultRate = 'DefaultRate',
  Rating = 'Rating',
  ProductType = 'ProductType',
}
